import React, { useState, useEffect } from "react";
import "../../styles/Login.css";
import { Link, useNavigate } from "react-router-dom";
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIRESTORE_API_KEY,
  authDomain: "wishuponaplayhouse.firebaseapp.com",
  projectId: "wishuponaplayhouse",
  storageBucket: "wishuponaplayhouse.firebasestorage.app",
  messagingSenderId: "513377368862",
  appId: "1:513377368862:web:eadda2a0b7bb141ffa670f",
};

const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
const auth = getAuth(app);

const Login = () => {
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  // If already signed in as the admin, skip the login page entirely
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      const allowedEmail = process.env.REACT_APP_ADMIN_EMAIL;
      if (user && (!allowedEmail || user.email === allowedEmail)) {
        navigate("/admin", { replace: true });
      } else {
        setChecking(false);
      }
    });
    return unsub;
  }, [navigate]);

  if (checking) return null; // brief flash prevention

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    // Reject non-admin emails before even hitting Firebase
    const allowedEmail = process.env.REACT_APP_ADMIN_EMAIL;
    if (allowedEmail && email !== allowedEmail) {
      setError("This account does not have admin access.");
      return;
    }
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/admin");
    } catch (err) {
      setError("Incorrect email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="SignInContainer">
      <div className="login-card">
        <h2>Admin Login</h2>
        <p>Sign in to manage your site content</p>
        <form onSubmit={handleSubmit}>
          <div className="inputField">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@example.com"
              required
              autoComplete="email"
            />
          </div>
          <div className="inputField">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              autoComplete="current-password"
            />
          </div>
          {error && <p className="login-error">{error}</p>}
          <div className="login-actions">
            <Link to="/" className="login-btn-secondary">Return Home</Link>
            <button type="submit" className="login-btn-primary" disabled={loading}>
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
